<template>
<v-card>
  <v-card-title class="secondary white--text">
    Quality Card
    <v-spacer></v-spacer>
    <v-btn dark small fab color="green" v-if="!value" @click="createQualityCard">
      <v-icon small>fa-plus</v-icon>
    </v-btn>
    <v-btn icon dark @click="show_quality_card=!show_quality_card" v-if="value">
      <v-icon v-if="show_quality_card">fa-minus</v-icon>
      <v-icon v-else>fa-chevron-down</v-icon>
    </v-btn>
  </v-card-title>
  <v-expand-transition v-if="value">
    <div v-show="show_quality_card">

      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
          <th class="text-left clicky">
            <quality-card-video v-model="value.congrats_video"></quality-card-video>
          </th>
          <th v-for="n in 10" :key="n" style="min-width:120px" :class="`text-center white--text rank-${n}-bg clicky`" @click="selectAllRank(n)">Rank {{n}}</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(category,i,k) in value.score" :key="k">
            <td class="caption" style="min-width:120px;">
             {{categories[i].label}}
            </td>
            <td v-for="n in 10" :key="n" style="min-width:120px;border-left:1px solid rgba(0, 0, 0, 0.12)" :class="`text-center ${category[n - 1] ? '' : 'secondary lighten-3'}`">


             <div v-if="category[n - 1]">
               <span :class="`rank-star rank-${n}-star`" >
                 <v-icon small v-if="category[n-1].reduce((c,j)=>c+j, 0) == category[n-1].length">fas fa-star</v-icon>
                  <v-icon small v-else>far fa-star</v-icon>
               </span>

               <span>
                 <quality-card-category v-model="category[n-1][0]" :disabled="disabled" :tip="categories[i].goals[n-1][0]"></quality-card-category>
                 <quality-card-category v-model="category[n-1][1]" :disabled="disabled" :tip="categories[i].goals[n-1][1]"></quality-card-category>
               </span>




             </div>

    <div v-else :class="`text-center`">
      <v-tooltip bottom v-if="k==4">
        <template v-slot:activator="{ on }">
                    <v-icon v-on="on" x-large dark>fa-lock</v-icon>
                    </template>
        <span>This rank is locked</span>
        </v-tooltip>
        <v-icon v-else>fa-blank</v-icon>
    </div>


    </td>


    </tr>
    </tbody>
    <tfoot>
      <tr style="border-top: 1px solid rgba(0, 0, 0, 0.12);">
        <th class="text-left">Total</th>
        <th v-for="n in 10" :key="n" style="min-width:120px" :class="`text-center white--text rank-${n}-bg`">
          <span>{{value.stars[n-1]}} / 10</span>
        </th>
      </tr>
    </tfoot>

    </template>
    </v-simple-table>
    </div>
  </v-expand-transition>
  <v-card-actions v-if="value" class="grey lighten-3">
    <v-chip label color="green" text-color="white">
      <v-avatar left class="white">
        <v-icon small :color="'green darken-2'">fa-dollar-sign</v-icon>
      </v-avatar>
      {{value.amount_earned |decimal}}
    </v-chip>
    <v-chip class="ml-4" label color="blue" text-color="white" v-if="value.bonus>0">
      <v-avatar left class="white">
        <v-icon small :color="'blue darken-2'">fa-plus</v-icon>
      </v-avatar>
      {{value.bonus |decimal}} Bonus
    </v-chip>
    <v-spacer></v-spacer>
  </v-card-actions>
</v-card>
</template>
<script>
import qualityCardVideo from "./quality_card_video"
import qualityCardCategory from "./quality_card_category"
import Vue from "vue";

export default {
  props: ['value', 'disabled'],
  name: "",
  components: {
    qualityCardVideo,
    qualityCardCategory
  },
  data: () => ({
    show_quality_card: true,
    modified: false,
    payscale: {
      1: 300,
      2: 300,
      3: 600,
      4: 1200,
      5: 2400,
      6: 4800,
      7: 9600,
      8: 19200,
      9: 38400,
      10: 76800
    }
  }),
  watch: {
    'value': {
      handler: function() {
        if (!this.disabled) {
          this.calculateStars()
        }

      },
      deep: true
    }
  },
  computed: {
    categories() {
      return this.$store.state.app.project_report_categories
    }
  },
  methods: {
    selectAllRank(i) {
      if (this.disabled) {
        return
      }
      let setTo = [1, 1]
      if (this.value.stars[i - 1] > 1) {
        setTo = [0, 0]
      }
      for (var k in this.value.score) {
        if (this.value.score[k][i - 1]) {
          Vue.set(this.value.score[k], [i - 1], setTo)
        }
      }
    },
    calculateStars() {
      for (var i = 1; i <= this.value.rank; i++) {
        let rankStars = 0;
        for (var k in this.value.score) {
          if (this.value.score[k][i - 1][0] === 1 && this.value.score[k][i - 1][1] === 1) {
            rankStars += 1;
          }
        }
        this.value.stars[i - 1] = rankStars
      }
      this.calculateEarnings()
    },
    calculateEarnings() {

      let total = 0;
      for (var i = 0; i < this.value.stars.length; i++) {
        let stars = this.value.stars[i];
        total += this.payscale[i + 1] * stars
      }
      this.value.amount_earned = total;


      //  this.value.amount_earned = this.payscale[this.value.rank] * this.value.stars[this.value.rank - 1]

    },
    saveCard() {
      this.$emit('input', this.value)
    },
    createQualityCard() {
      this.$emit('new')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
